import AxiosInstance from '../../core/api/axiosinstance'
import { PatentStatus } from '../../shared/enum'
import { promiseToResult, querystring } from '../../utils'
import { Content } from './_type'

export interface Project {
  id: number
  name: string
  allShares: string
  allSharesForSelling: string
  soldShares: string
  availableSharesPercent: string
  todaySharePrice: number
  yesterdaySharePrice: number
  symbol: string
  percentCompanyToOneBuilding: number
  percentCompanyToOneShare: number
  pricePerOneBuilding: number
  icon: string
  coin: string
}
export interface ProjectSections {
  about: {
    content: Content[]
    videoUrl: Content[]
    presentationUrl: Content[]
    patents: {
      code: string
      url: string
      status: PatentStatus
    }[]
    awards: string[]
  }
  shares: {
    content: Content[]
  },
  development: {
    content: Content[]
    steps: {
      content: Content[]
      title: Content[],
      progresses: {
        content: Content[]
        progress: number
      }[]
    }[]
  },
  news: {
    content: Content[]
  }
  dividend: {
    content: Content[]
  }
}

export type GetProjectsRes = Project[]
const getProjects = () => {
  return promiseToResult(AxiosInstance().get<GetProjectsRes>(
    '/projects/projects',
  ))
}

export interface GetProjectReq {
  symbol: string
}
export type GetProjectRes = Project
const getProject = (data: GetProjectReq) => {
  const { symbol } = data
  return promiseToResult(AxiosInstance().get<GetProjectRes>(
    `/projects/projects/${symbol}`,
  ))
}

export interface GetProjectSectionsReq {
  symbol: string
}
export type GetProjectSectionsRes = ProjectSections
const getProjectSections = (data: GetProjectSectionsReq) => {
  const { symbol } = data
  return promiseToResult(AxiosInstance().get<GetProjectSectionsRes>(
    `/projects/projects/${symbol}/sections`,
  ))
}

export interface GetProjectHistoryReq {
  symbol: string
  limit: number
  step: 'month' | 'day' | 'hour' | string
}
export type GetProjectHistoryRes = {
  price: number
  appliedAt: string
  projectId: number
}[]
const getProjectHistory = (data: GetProjectHistoryReq) => {
  const { symbol, limit, step } = data
  return promiseToResult(AxiosInstance().get<GetProjectHistoryRes>(
    `/projects/projects/${symbol}/history?${querystring.stringify({ limit, step })}`,
  ))
}

export const ProjectAPI = {
  getProjects,
  getProject,
  getProjectSections,
  getProjectHistory,
}
